module.exports = __webpack_public_path__ + "img/minimap-monde.3a3c6d36.png";